import type { Degree } from "../units/Units"
import type { PlotFunction } from "./PlotFunction"

// Base type for common properties
export type BasePlotObject = {
  enum: PlotFunction
  rotation?: Degree
}

// Base type for common properties
export type ConcretePlotObject = {
  stroke_color?: string
  fill_color?: string
} & BasePlotObject
